// extracted by mini-css-extract-plugin
export var adjacentSlide = "_o4-9";
export var arrowButtonContainer = "_o4-5";
export var arrowButtonIcon = "_o4-6";
export var carouselArrowButton = "_o4-2";
export var carouselElementContainer = "_o4-1";
export var currentSlide = "_o4-8";
export var left = "_o4-3";
export var otherSlide = "_o4-a";
export var productCarouselContainer = "_o4-0";
export var right = "_o4-4";
export var sliderOverflow = "_o4-7";